
import { Route, Routes } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout/AuthLayout';
import DashboardLayout from '../layouts/DashboardLayout/DashboardLayout';
import Documents from '../pages/Documents/Documents';
import Analytics from '../pages/Analytics/Analytics';
import Login from '../pages/Login/Login';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import VerifyOTP from '../pages/VerifyOTP/VerifyOTP';
import PrivateOutlet from './PrivateOutlet/PrivateOutlet';
import RedirectOutlet from './RedirectOutlet/RedirectOutlet';

const Index = () => {

  return (
      <Routes>
        <Route path='/' element={<RedirectOutlet />}>
          <Route path='/' element={<AuthLayout />}>
            <Route path='' index element={<Login />} />
            <Route path='reset-password' element={<ResetPassword />} />
            <Route path='verify-otp' element={<VerifyOTP />} />
          </Route>
        </Route>
        <Route path='/' element={<PrivateOutlet />}>
          <Route path='/' element={<DashboardLayout />}>
            <Route path='/dashboard' element={<Documents />} />
            <Route path='/analytics' element={<Analytics />} />
          </Route>
        </Route>
      </Routes>
  );
};

export default Index;
